import { default as dayjs } from "dayjs"
import ko from "dayjs/locale/ko"
import ja from "dayjs/locale/ja"
import { LOCALES } from "constants/locales"

const language_localeSettings_map = {
  [LOCALES.KO]: ko,
  [LOCALES.JA]: ja,
}

export const changeLocale = (dayjs, language) => {
  dayjs.locale({
    ...language_localeSettings_map[language],
    weekStart: 1,
  })
}

export default dayjs
